// extracted by mini-css-extract-plugin
module.exports = {"promo__wrapper":"promo__wrapper-1wt6L","promo__image":"promo__image-UosII"};